import HTTP from '@/utils/http-common';
// import { encodeOpts } from '../utils/encode-opts';
const config = { headers: { 'Content-Type': 'multipart/form-data' } };

export const createPartMedia = async (media, product, part) =>
  (await HTTP.post(`/products/${product}/parts/${part}/media`, media)).data;
export const deleteMedia = async (media) => (await HTTP.delete(`/product-media/${media}`)).data;
export const updateMedia = async (media) => (await HTTP.put(`/product-media/${media._id}`, media)).data;
export const patchMedia = async (media) => (await HTTP.patch(`/product-media/${media._id}`, media)).data;
export const uploadMediaPreview = async (media) =>
  (await HTTP.post(`/product-media/${media.get('mediaId')}/preview`, media, config)).data;
export const createProductMedia = async (product, media) => (await HTTP.post(`/products/${product}/media`, media)).data;
export const createLocationMedia = async (media, productId, locationId) =>
  (await HTTP.post(`/products/${productId}/locations/${locationId}/media`, media)).data;
export const createDecorationMedia = async (media, productId, locationId, decorationId) =>
  (await HTTP.post(`/products/${productId}/locations/${locationId}/decorations/${decorationId}/media`, media)).data;
